import { render, staticRenderFns } from "./OauthClientList.vue?vue&type=template&id=03de5584&scoped=true"
import script from "./OauthClientList.vue?vue&type=script&lang=js"
export * from "./OauthClientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03de5584",
  null
  
)

export default component.exports